<script setup lang="ts">
import type { LinkNavTab } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationLinkTabs } from '@shared/ui/menus'

defineOptions({
  name: 'SlotsManagementMenu',
})

const route = useRoute()

const config = computed<LinkNavTab[]>(() => [
  {
    text: 'Booking',
    to: AppRoute.DemosSlotsManagement,
    selected: route.path === AppRoute.DemosSlotsManagement,
    disabled: false,
    visible: true,
  },
  {
    text: 'Sales queue',
    to: AppRoute.DemosSlotsManagementSalesQueue,
    selected: route.path === AppRoute.DemosSlotsManagementSalesQueue,
    disabled: false,
    visible: true,
  },
])
</script>

<template>
  <NavigationLinkTabs :config="config" />
</template>
